import { jsxs as i, jsx as a } from "react/jsx-runtime";
import { Container as s, WrapperLeft as c, CategoryIcon as n, Text as p, IconSelect as m } from "./style.js";
import { CircleCheckSolid as C } from "@pelando/fontawesome/icons";
function g({
  title: o,
  className: d,
  active: e,
  onClick: l,
  icon: t,
  light: r
}) {
  return /* @__PURE__ */ i(
    s,
    {
      onClick: l,
      className: d,
      "aria-selected": e,
      "data-is-light": r,
      children: [
        /* @__PURE__ */ i(c, { children: [
          t && /* @__PURE__ */ a(
            n,
            {
              icon: t,
              "aria-selected": e,
              "data-is-light": r
            }
          ),
          /* @__PURE__ */ a(p, { "aria-selected": e, "data-is-light": r, children: o })
        ] }),
        /* @__PURE__ */ a(
          m,
          {
            icon: C,
            "aria-selected": e,
            "data-is-light": r
          }
        )
      ]
    }
  );
}
export {
  g as CategoryCapsuleIcon
};
